;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import RichText from 'components/ui/RichText';

import { overrides } from './overrides';

import styles from './Directions.module.scss';

const Directions = ({ richText }) => {
    return (
        <section className={styles.directions}>
            {richText && <RichText richText={richText} overrides={overrides} />}
        </section>
    );
};

Directions.propTypes = {
    richText: PropTypes.object,
};

export default Directions;
